var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-pdf-detail"},[_c('div',{staticClass:"container"},[_c('order-detail-meta',{attrs:{"id":_vm.id,"mode":"pdf"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }